const ANKI_CONNECT_URL =
  process.env.REACT_APP_ANKI_CONNECT_URL || "http://127.0.0.1:8765";

const invoke = async (action, params = {}, version = 6) => {
  const res = await fetch(ANKI_CONNECT_URL, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ action, version, params }),
  });

  if (!res.ok) {
    const text = await res.text();
    throw new Error(text || `AnkiConnect request failed: ${res.status}`);
  }

  const payload = await res.json();
  if (payload?.error) {
    throw new Error(payload.error);
  }
  return payload?.result;
};

export const checkAnkiConnection = async () => invoke("version");

export const ensureAnkiDeck = async (deckName) => {
  const name = String(deckName || "Obey The Bell").trim() || "Obey The Bell";
  await invoke("createDeck", { deck: name });
  return name;
};

export const addBasicNotesToAnki = async (cards = []) => {
  const notes = cards
    .map((card) => {
      const front = String(card?.front || "").trim();
      const back = String(card?.back || "").trim();
      if (!front || !back) return null;
      const deckName = String(card?.deckName || "Obey The Bell").trim() || "Obey The Bell";
      const tags = Array.isArray(card?.tags)
        ? card.tags.map((tag) => String(tag || "").trim()).filter(Boolean)
        : [];
      return {
        deckName,
        modelName: "Basic",
        fields: {
          Front: front,
          Back: back,
        },
        tags,
      };
    })
    .filter(Boolean);

  if (!notes.length) {
    return [];
  }

  const deckNames = Array.from(new Set(notes.map((note) => note.deckName)));
  await Promise.all(deckNames.map((deckName) => ensureAnkiDeck(deckName)));

  return invoke("addNotes", { notes });
};
